export default "__VITE_ASSET__BOuNF$lI__"